import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { formatDate } from '@utils/date'
import translate from '@i18n'
import SecondaryCTAButton from '@components/Buttons/SecondaryCTAButton'

import ActionsResponding from './ActionsResponding'
import AnswerIndicator from './AnswerIndicator'
import DatePublished from './DatePublished'
import ItemContent from './ItemContent'
import ItemHeader from './ItemHeader'
import ItemSuperUserIndicator from './ItemSuperUserIndicator'
import TextContent from './TextContent'
import { PostedCommentingItemProps } from './types'
import {
  getGenderAdjustedSuperUserTitle,
  getIsAuthorTypeSuperUser,
} from './utils'

const AuthorName = styled.div`
  ${({
    theme: {
      typography: {
        headings: {
          xsmall: { bundledCSS: headingXSmallCSS },
        },
      },
    },
  }) => css`
    ${headingXSmallCSS};
  `}
`

const ItemActions = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const PostedCommentingItem: FunctionComponent<PostedCommentingItemProps> = ({
  type,
  authorType,
  gender,
  authorName,
  datePublished,
  textContent,
  onDelete,
}) => {
  const isSuperUser = getIsAuthorTypeSuperUser(authorType)

  return (
    <>
      {type === 'answer' && <AnswerIndicator />}
      <ItemContent type={type}>
        {isSuperUser ? (
          <ItemSuperUserIndicator
            userTitle={getGenderAdjustedSuperUserTitle(authorType, gender)}
          />
        ) : null}
        <ItemHeader>
          <AuthorName>{authorName}</AuthorName>
          <DatePublished>
            {formatDate(datePublished)
              ? (formatDate(datePublished) as any)?.dateOrTime
              : ''}
          </DatePublished>
        </ItemHeader>
        <TextContent>{textContent}</TextContent>
        <ItemActions>
          <ActionsResponding>
            <SecondaryCTAButton
              colorVariant="black"
              onClick={onDelete}
              size="small"
            >
              {translate('commenting.delete')}
            </SecondaryCTAButton>
          </ActionsResponding>
        </ItemActions>
      </ItemContent>
    </>
  )
}

export default PostedCommentingItem
